<script lang="ts">
import { defineComponent, h } from "vue";
import { serializeJsonLd } from "../../../utils/jsonld";

// Renders a <script type="application/ld+json"> tag with the given data
// serialized as raw JSON. Using `innerHTML` (rather than a text child) keeps
// the JSON intact through SSR — Vue escapes text children, which would corrupt
// characters like & and < inside the script and break the JSON-LD.
//
// The "<" -> "<" replacement prevents the JSON from ever closing the
// surrounding <script> tag early (defense-in-depth, mirrors how the SSR state
// is serialized in server.js).
export default defineComponent({
  name: "VfAJsonLd",
  props: {
    data: {
      type: [Object, Array],
      default: null,
    },
  },
  render() {
    if (!this.data) return null;
    const json = serializeJsonLd(this.data);
    if (!json || json === "null") return null;
    return h("script", {
      type: "application/ld+json",
      innerHTML: json,
    });
  },
});
</script>
